package com.klantenstop.web.pages.admin.settings

import com.klantenstop.web.utils.MVI

interface SettingsContract : MVI<SettingsContract.State, SettingsContract.Intent, SettingsContract.Effect> {

    data class State(
        val isLoading: Boolean = false,
        val isSaving: Boolean = false,
        // General settings
        val siteName: String = "",
        val siteDescription: String = "",
        val contactEmail: String = "",
        val contactPhone: String = "",
        // Security settings
        val sessionTimeout: Int = 30,
        val passwordMinLength: Int = 8,
        // Search settings
        val defaultSearchRadius: Int = 10,
        val maxSearchRadius: Int = 50,
        // Review settings
        val reviewModerationEnabled: Boolean = true,
        val minimumRating: Int = 1
    )

    sealed class Intent {
        data object LoadSettings : Intent()
        data class UpdateSiteName(val name: String) : Intent()
        data class UpdateSiteDescription(val description: String) : Intent()
        data class UpdateContactEmail(val email: String) : Intent()
        data class UpdateContactPhone(val phone: String) : Intent()
        data class UpdateSessionTimeout(val timeout: Int) : Intent()
        data class UpdatePasswordMinLength(val length: Int) : Intent()
        data class UpdateDefaultSearchRadius(val radius: Int) : Intent()
        data class UpdateMaxSearchRadius(val radius: Int) : Intent()
        data class UpdateReviewModeration(val enabled: Boolean) : Intent()
        data class UpdateMinimumRating(val rating: Int) : Intent()
        data object SaveSettings : Intent()
    }

    sealed class Effect {
        data class ShowError(val message: String) : Effect()
        data class ShowSuccess(val message: String) : Effect()
    }
}

